import type { $ZodIssue } from "@zod/core";

export const API_ERROR_CODES = [
  "PARSE_ERROR",
  "BAD_REQUEST",
  "INTERNAL_SERVER_ERROR",
  "NOT_IMPLEMENTED",
  "BAD_GATEWAY",
  "SERVICE_UNAVAILABLE",
  "GATEWAY_TIMEOUT",
  "UNAUTHORIZED",
  "FORBIDDEN",
  "NOT_FOUND",
  "METHOD_NOT_SUPPORTED",
  "TIMEOUT",
  "CONFLICT",
  "PRECONDITION_FAILED",
  "PAYLOAD_TOO_LARGE",
  "UNSUPPORTED_MEDIA_TYPE",
  "UNPROCESSABLE_CONTENT",
  "TOO_MANY_REQUESTS",
  "CLIENT_CLOSED_REQUEST",
] as const;

export type APIErrorCode = (typeof API_ERROR_CODES)[number];

export type APIErrorShape = {
  code: number;
  data?: {
    code: APIErrorCode;
    httpStatus: number;
    path: string;
    zodError?: {
      fieldErrors?: Record<string, $ZodIssue[]>;
      formErrors?: $ZodIssue[];
    };
  };
  message?: string;
};

export type ZodIssue = $ZodIssue;
